import React from 'react';
import { createSvgIcon } from '@mui/material';

const CustomPersonUpdate = createSvgIcon(
  <path
    clipRule="evenodd"
    fillRule="evenodd"
    d="M9 20h13v-3c0-2.66-5.33-4-8-4-.986 0-2.334.183-3.642.547A5 5 0 1 0 9 20m11.1-3c0-.64-3.13-2.1-6.1-2.1-1.042 0-2.104.18-3.043.44q.043.325.043.66a5 5 0 0 1-.461 2.1H20.1zM6.55 19.42c-.187.172-.511.05-.511-.195v-.445h-.036a3.14 3.14 0 0 1-2.126-.812c-.859-.795-1.087-1.957-.684-2.947.114-.283.516-.355.744-.139a.41.41 0 0 1 .102.456c-.276.69-.12 1.49.48 2.046.421.39.974.573 1.526.562v-.523c0-.25.324-.372.51-.194l.973.9c.12.112.12.284 0 .395zm1.519-2.297a.41.41 0 0 1-.102-.456c.276-.69.12-1.49-.48-2.046a2.17 2.17 0 0 0-1.52-.567v.523c0 .25-.324.372-.51.194l-.98-.895a.26.26 0 0 1 0-.395l.974-.9c.186-.173.51-.05.51.194v.45c.78-.01 1.567.25 2.162.807.859.795 1.087 1.957.684 2.947-.114.289-.51.361-.738.144M10 8c0-2.21 1.79-4 4-4s4 1.79 4 4-1.79 4-4 4-4-1.79-4-4m6.1 0a2.1 2.1 0 1 0-4.2 0 2.1 2.1 0 0 0 4.2 0"
  />,
  'CustomPersonUpdate',
);

export default CustomPersonUpdate;
